@use "@fukuri-admins/ui/layout" as *;

.root {
  box-sizing: border-box;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @media (max-width: 1140px) {
    padding: 96px 48px;
  }
  @media (max-width: 700px) {
    padding: 48px;
  }
  @media (max-width: 540px) {
    padding: 24px;
  }
}

.mainContainer {
  width: 100%;
}

.form {
  max-width: 400px;
  margin: 0 0 24px;
  text-align: left;
  color: $Text;
  font-size: 16px;
  .formTitle {
    color: $TextInput;
    font-size: 14px;
    margin-bottom: 4px;
    font-weight: 600;
    text-align: left;
    @media (max-width: 440px) {
      font-size: 12px;
    }
  }
  &.formName {
    display: flex;
    align-items: center;
    gap: 16px;
  }
}

.formBtn {
  margin-top: 32px;
  @media (max-width: 540px) {
    margin-top: 24px;
    transition-delay: 300ms;
    transition-duration: 1000ms;
  }
}

.btnContainer {
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 570px) {
    display: block;
  }
}

.cancelBtn {
  width: 100% !important;
  margin-right: 8px;
}

.confirmBtn {
  width: 100% !important;
  @media (max-width: 570px) {
    margin-left: 0px;
  }
}

.formDiscription {
  color: #55727e;
  font-family: "Noto Sans JP"; //20230111
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
  letter-spacing: 0em;
  text-align: left;
  transition-delay: 400ms;
  transition-duration: 1000ms;
  margin-bottom: 20px;
  @media (max-width: 440px) {
    font-size: 12px;
    transition-delay: 300ms;
    transition-duration: 1000ms;
  }
}

.symbol {
  color: #f23a3c;
  font-family: "Noto Sans JP"; //20230111
  font-size: 15px;
  font-weight: 700;
  line-height: 1.4;
  margin-right: 5px;
}

.formInput {
  color: #000;
  font-family: "Noto Sans JP"; //20230111
  font-weight: 400;
  font-size: 18px;
  line-height: 29px;
  text-align: center;
}
.addBtn {
  cursor: pointer;
  width: fit-content;
  color: #000;
  //font-family: "ヒラギノ角ゴ W6 JIS2004";
  font-family: "Noto Sans JP";
  font-size: 18px;
  font-weight: 600;
  height: auto;
  line-height: 1.4;
  margin-bottom: 50px;
  & i {
    margin-left: 10px;
    font-size: 18px;
    line-height: 18px;
    color: #000;
  }
  &:hover {
    opacity: 0.5;
  }
}

.clearBtn {
  cursor: pointer;
  width: fit-content;
  color: #000;
  //font-family: "ヒラギノ角ゴ W6 JIS2004";
  font-family: "Noto Sans JP";
  font-size: 14px;
  font-weight: 600;
  height: auto;
  line-height: 1.4;
  margin-bottom: 50px;
  & i {
    margin-left: 10px;
    font-size: 18px;
    line-height: 18px;
    color: #000;
  }
  &:hover {
    opacity: 0.5;
  }
}

.name {
  display: flex;
  align-items: center;
  width: 100%;
}

.kome {
  font-size: 12px;
}

.formMiddle {
  font-size: 16px;
  color: $Text;
  max-width: 100%;
  width: 100%;
  padding: 8px 8px;
}

.formShort {
  max-width: 100%;
  width: 189px;
}

.marginRight24 {
  margin-right: 24px;
}

.errorMessage {
  color: red;
  font-family: "Noto Sans JP"; //20230111
  font-weight: 800;
  font-size: 14px;
  line-height: 22px;
  text-align: left;
}
